// src/theme/RtlProvider.js
import React, { useEffect } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import stylisRTLPlugin from 'stylis-plugin-rtl';

// Create an emotion cache with RTL plugin
const cacheRtl = createCache({
  key: 'mui-rtl',
  stylisPlugins: [stylisRTLPlugin],
});

export default function RtlProvider({ children }) {
  useEffect(() => {
    // Set HTML dir attribute to rtl for proper text direction
    document.documentElement.setAttribute('dir', 'rtl');
  }, []);

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}
